/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import { getMinPrice } from "../../Common/HOC/Hoc";

import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  ClientInfo,
  Dispatch,
  formatPrice,
  GetProdBudSumData,
  handleLimit,
  LoginV3Data,
  MaxQuan,
  showMaxMessg,
  SupplierCapping,
  trackEvent,
} from "../Utility/Utility";
import { onShowFailureReset } from "../../Store/Slices/cardDataSlice";
import { useRef } from "react";
import RewardWidget from "../RewardWidget/RewardWidget";
import { encryptURLParam } from "../../Common/Axios/encrypt";
import { onGetCustomerProduct } from "../../Store/Slices/customerProductSummarySlice";
import PurchaseLimitAlertTile from "../PurchaseLimitAlertTile/PurchaseLimitAlertTile";
import soldout from "../../Assets/soldout.png";
const inFlightCustomerProductKeys = new Set();

const RedemptionDetails = ({ productReducer, isMobile }) => {
  const dispatch = Dispatch();
  const maxQuan = MaxQuan();
  const supplierCapping = SupplierCapping();
  const translation = getTranslationData();
  const navigate = useNavigate();
  const [finalAmount, setFinalAmount] = useState(0);
  const [arrayData, setArrayData] = useState([]);
  const [convenienceFee, setConvenienceFee] = useState(0);
  const [gst, setGst] = useState(0);
  const isLogin = sessionStorage.getItem("login");
  const location = useLocation();
  const { moduleData } = location.state || {};
  const hasTracked = useRef(false);
  const [eventData, setEventData] = useState([]);

  //const [selectedCard, setSelectedCard] = useState({});
  const loginV3Data = LoginV3Data();
  const prodSumData = GetProdBudSumData();
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [stockOutDenominations, setStockOutDenominations] = useState();
  const [outOfStockLabel, setOutOfStockLabel] = useState([]);
  const cardListData = useSelector((state) => state.clientConfigDataReducer);
  const clientInfo = useSelector((state) => state.clientDataReducer);
  const rewardWidgetConfig = clientInfo?.clientData?.clientConfigurations?.find((config) => config.configKey === "isrewardwidgete");
  // const productDiscount = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer.data?.[0]?.clientProductMapping
  // );
  // const minEarnPoints = productDiscount?.find(
  //   (entry) => entry.productId === productReducer?.productReducer?.id
  // );
  // const categoryAllData = useSelector(
  //   (state) => state?.userRoleSliceReducer?.categoryData
  // );
  const categoryAllData = useSelector(
    (state) => state.userRoleSliceReducer.categoryData
  );
  const catergoryData = categoryAllData.filter(
    (category) => category?.id === productReducer.productReducer?.categoryId
  );

  const minEarn = productReducer?.productReducer?.minEarnPoints || 0;
  let priceDenominations = [];
  const priceData = productReducer?.productReducer?.clientProductDenomination;
  const [earnPointsPerDenomination, setEarnPointsPerDenomination] = useState(
    priceDenominations.map(() => 0)
  );
  useEffect(() => {
    if (priceData) {
      priceDenominations = priceData.map((item) => item?.denomination);
      setStockOutDenominations(priceData.every((item) => item?.stockOut === true));
      setOutOfStockLabel(priceData.map(item => { return item?.stockOut }));

    }
  }, [priceData]);

  if (Array.isArray(priceData)) {
    priceDenominations = priceData.map(item => item?.denomination);

  }
  else {
    priceDenominations = [];
  }
  const discount =
    Number(productReducer?.productReducer?.customerDiscount) || 0;
  const V3Data = useSelector((state) => state.cardDataSliceReducer);

  // Initialize quantities to 0 for all price denominations
  const initialQuantities = priceDenominations.map(() => 0);
  const [quantities, setQuantities] = useState(initialQuantities);

  useEffect(() => {
    if (moduleData) {
      const newQuantities = priceDenominations.map((price) => {
        const match = moduleData.find((item) => item.denomination === price);
        return match ? match.quantity : 0;
      });
      setQuantities(newQuantities);
    } else {
      setQuantities(initialQuantities);
    }
  }, [productReducer, moduleData]);

  useEffect(() => {
    if (productReducer && typeof productReducer === "object") {
      const fee = Number(productReducer.productReducer.convenienceFee);
      const tax = Number(productReducer.productReducer.gst);

      setConvenienceFee(isNaN(fee) ? 0 : fee);
      setGst(isNaN(tax) ? 0 : tax);
    } else {
      setConvenienceFee();
      setGst(0);
    }
  }, [productReducer]);
  useEffect(() => {
    handleLimit(
      finalAmount,
      prodSumData?.getCustomerProduct,
      dispatch,
      translation,
      productReducer?.productReducer?.productBudget?.limits
    );
  }, [finalAmount]);
  const handleIncrease = (index, value) => {
    const nextValue = quantities[index] + 1;
    setQuantities((prevQuantities) => {
      const newQuantities = [...prevQuantities];
      newQuantities[index] = nextValue;

      if (supplierCapping > 0 && nextValue === supplierCapping) {
        showMaxMessg(
          translation.max_capping_allowed,
          supplierCapping,
          1,
          value
        );
      }

      setEarnPointsPerDenomination((prev) => {
        const updatedEarnPoints = [...prev];
        updatedEarnPoints[index] = calculateEarnPoints(value);

        // Build eventData preserving original indices so denominations map correctly
        const combined = newQuantities
          .map((qty, i) => {
            if (!qty || qty <= 0) return null;
            return {
              quantity: qty,
              gift_card_points: priceDenominations[i],
              price:
                priceDenominations[i] -
                (priceDenominations[i] * discount) / 100,
              item_id: productReducer?.productReducer?.sku || "",
              item_brand: productReducer?.productReducer?.name || "",
              item_name: productReducer?.productReducer?.name || "",
              affiliation: "IDFC Store",
              item_category: "Gift Card",
              item_category2: catergoryData?.[0]?.name || "",
              item_image: productReducer?.productReducer?.small || "",
              item_url: window.location.href,
            };
          })
          .filter(Boolean);
        setEventData(combined);
        return updatedEarnPoints;
      });

      return newQuantities;
    });
  };

  const handleDecrease = (index, value) => {
    setQuantities((prevQuantities) => {
      const newQuantities = [...prevQuantities];

      if (newQuantities[index] > 0) {
        newQuantities[index] -= 1;
      }

      setEarnPointsPerDenomination((prev) => {
        const updatedEarnPoints = [...prev];
        updatedEarnPoints[index] =
          newQuantities[index] > 0
            ? calculateEarnPoints(priceDenominations[index])
            : 0;
        return updatedEarnPoints;
      });
      const combined = newQuantities
        .map((qty, i) => {
          if (!qty || qty <= 0) return null;
          return {
            quantity: qty,
            earnPoint: calculateEarnPoints(priceDenominations[i]),
            priceDenomination: priceDenominations[i],
          };
        })
        .filter(Boolean);

      setEventData(combined);

      return newQuantities;
    });
  };
  useEffect(() => {
    const newFinalAmount = priceDenominations.reduce((acc, price, index) => {
      return acc + price * quantities[index];
    }, 0);

    const newArrayData = priceDenominations
      .map((item, index) => {
        const qty = quantities[index] || 0;
        if (qty > 0) {
          return {
            denomination: item,
            you_pay: (item - (item * discount) / 100).toFixed(2),
            saving: ((item * discount) / 100).toFixed(2),
            quantity: quantities[index],
          };
        }
        return null; // mark invalid ones
      })
      .filter((obj) => obj !== null);

    setArrayData(newArrayData);
    setFinalAmount(newFinalAmount);
  }, [quantities, discount, convenienceFee, gst]);

  const totalGiftcard = quantities.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  );

  const handleClick = () => {
    // dispatch(onShowFailureReset());
    const finalValue =
      finalAmount -
      (finalAmount * discount) / 100 +
      ((finalAmount - (finalAmount * discount) / 100) * convenienceFee) / 100 +
      (((finalAmount - (finalAmount * discount) / 100) * convenienceFee) /
        100) *
      (gst / 100);
    const finalDiscount = (finalAmount * discount) / 100;
    const selectedCard = localStorage.getItem("RewardWidget");
    const cardData = cardListData?.clientConfigData?.cards?.find(
      (card) => card.cardId === selectedCard
    );
    let rewardPoints = 0;
    if (cardData) {
      rewardPoints = Math.floor(
        (finalValue / cardData.perRs) *
        cardData.standardPoints *
        (cardData.bonusPoints / cardData.standardPoints + 1)
      );
    }

    if (maxQuan > 0 && totalGiftcard > maxQuan) {
      showMaxMessg(translation.max_limit_allowed, maxQuan);
    } else if (totalGiftcard > 0) {
      trackEvent("add_to_cart", {
        currency: "INR",
        value: finalValue,
        discount: finalDiscount,
        total_gift_card_points: priceDenominations.reduce(
          (sum, denomination, index) => {
            return sum + denomination * quantities[index];
          },
          0
        ),
        card_name: selectedCard,
        reward_points: rewardPoints,
        items: eventData || [],
      });
      if (!isLogin) {
        // Conditionally encrypt productId parameter for localStorage based on environment setting
        const productIdValue = productReducer?.productReducer?.id.toString();
        const finalProductId =
          process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
            ? productIdValue
            : encryptURLParam(productIdValue);
        const pathName = window.location.pathname;
        const search = window.location.search;
        localStorage.setItem(
          "ProductListPage",
          `/card?productId=${finalProductId}`
        );
        localStorage.setItem("ProductListPage_back", pathName + search);
        sessionStorage.setItem("arrayData", JSON.stringify(arrayData));
        window.location.href =
          V3Data?.SignInUrl +
          "/GIFTSTACC/SXNQb3N0UmVnaXN0cmF0aW9uTG9naW49dHJ1ZQ==";
      } else {
        // Conditionally encrypt productId parameter for navigation based on environment setting
        const productIdValue = productReducer?.productReducer?.id.toString();
        const finalProductId =
          process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
            ? productIdValue
            : encryptURLParam(productIdValue);
        navigate(`/card?productId=${finalProductId}`, {
          state: { arrayData },
        });
      }
    } else {
      toast.error("Please add the product");
    }
  };

  const calculateEarnPoints = (item) => {
    return Math.round(
      (minEarn / getMinPrice(priceDenominations)) *
      (item - (item * discount) / 100)
    );
  };

  useEffect(() => {
    const pid =
      productReducer?.productReducer?.id ??
      productReducer?.productReducer?.sku ??
      "";
    if (!pid) return;

    // global guard so strict-mode double mount won't re-send the same event
    const tracked =
      window.__trackedViewItems || (window.__trackedViewItems = new Set());
    const key = `view_item:${pid}`;
    if (tracked.has(key)) return;
    tracked.add(key);
    trackEvent("view_item", {
      page_url: window.location.href,
      items: [
        {
          id: productReducer?.productReducer?.id,
          item_name: productReducer?.productReducer?.name,
          item_id: productReducer?.productReducer?.sku,
          item_category: "Giftcard",
          item_category2: catergoryData?.[0]?.name || "",
          item_brand: productReducer?.productReducer?.name,
          affiliation: "IDFC Store",
          item_image: productReducer?.productReducer?.small,
          item_url: productReducer?.productReducer?.url,
          offer_type: productReducer?.productReducer?.type || "",
        },
      ],
    });
  }, []);
  const clientinfo = ClientInfo();
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isEarnView = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearnview"
  )?.configValue;
  useEffect(() => {
    document.body.classList.add("redemption-details-active");
    return () => {
      document.body.classList.remove("redemption-details-active");
    };
  }, []);
  // useEffect(() => {
  //   if (loginV3Data?.memberIdentifier && productReducer?.productReducer?.id) {
  //     dispatch(
  //       onGetCustomerProduct({
  //         customerId: loginV3Data.memberIdentifier,
  //         productIdentifier: productReducer.productReducer.id,
  //       })
  //     );
  //   }
  // }, []);
  const memberId = `${loginV3Data?.memberIdentifier ?? ""}`;
  const productId = `${productReducer?.productReducer?.id ?? ""}`;
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!memberId || !productId) return;

    const key = `${memberId}:${productId}`;
    if (hasFetched.current || inFlightCustomerProductKeys.has(key)) return;

    hasFetched.current = true;
    inFlightCustomerProductKeys.add(key);
    dispatch(
      onGetCustomerProduct({
        customerId: memberId,
        productIdentifier: productId,
      })
    );

    return () => {
      const RELEASE_DELAY_MS = 3000;
      setTimeout(
        () => inFlightCustomerProductKeys.delete(key),
        RELEASE_DELAY_MS
      );
    };
  }, [memberId, productId]);
  return (
    <div className="redemption-details-page">
      <ToastContainer />
      {stockOutDenominations ? (
        <div className="row">

          <div className="col-lg-4"></div>
          <div className="col-lg-8 col-12">
            <div className="mod-head redeem-padd mt-0">
              <h5 className="heading1 mb-0">

                {translation.AvailabilityOfDenominations}

              </h5>
            </div>
            <div className="redemption_soldOutBox text-center mt-2 mb-4">

              <div className="stockout-image ">
                <img src={soldout} alt="Sold Out" className="mb-1" />
                <p className="stockout-text ">
                  {translation?.stock_out}
                </p>
                <p>{translation?.stockout_message_desc_all_denomination}

                </p>
              </div>
            </div>
            <div className="mobile-sticky-footer">
              <div className="mt-3 redem-buy-sp text-center mb-2 giftBuyBtn">
                <a
                  className="continue-wh buy-detailpro buy-stockupDetailpro"
                  // onClick={V3Data?.disable ? undefined : handleClick}
                  style={{
                    cursor: "not-allowed",
                    backgroundColor: "var(--disable-continue-color)"
                  }}
                >
                  {translation?.continue}
                </a>
              </div>
              <div className="redeem-padd info-box text-center redeem-pt">
                {/* <span className="redeem-txt-clr">{`${translation?.redeem_text} `}</span> */}
                {translation?.pay_with_membership_rewards_at_safekey_checkout}
              </div>
            </div>
          </div>

        </div>
      ) : (
        <div key={productReducer?.productReducer?.productId} className="row">
          {(!isMobile && rewardWidgetConfig?.configValue === 1) && <div className="col-lg-6 col-12">
            <RewardWidget
              totalAmount={
                finalAmount -
                (finalAmount * discount) / 100 +
                ((finalAmount - (finalAmount * discount) / 100) * convenienceFee) /
                100 +
                (((finalAmount - (finalAmount * discount) / 100) * convenienceFee) /
                  100) *
                (gst / 100)
              }
              className={V3Data?.disable ? "mt-3" : ""}
            />
          </div>
          }
          <div className={`${rewardWidgetConfig?.configValue === 1 ? "col-lg-6" : "col-lg-12"} col-12`}>
            <div className="mod-head redeem-padd mt-0">
              <h5 className="heading1 mb-0">
                {maxQuan !== 0 && translation?.chooseYourDenomination && (
                  <>
                    {translation.chooseYourDenomination} (up to {maxQuan})
                  </>
                )}
              </h5>
            </div>
            {priceDenominations.map((item, index) => (
              <div className="row p-2 align-card" key={index}>
                <div className="first-new col-lg-6 col-9">
                  <div className="d-flex justify-content-start mb-3" style={outOfStockLabel?.[index] ? { filter: "grayscale(1)", opacity: '0.6' } : {}}>
                    <div className="mrg-lft">
                      <div
                        className="amount-box"
                      // className="background_image"
                      // style={{ backgroundImage: url(${bgImage}) }}
                      >
                        <div className="price_in_box rs_price">
                          <span className="currency">₹</span>
                          <span className="amount">{item}</span>
                        </div>
                        {/* <img
                      alt="not-found"
                      src={boxLine}
                      className="point-box-line"
                    /> */}
                      </div>
                    </div>
                    <div className="font-blk mr-10 col-lg-3 col-3 mrg-b padd-lft">
                      <span>
                        {productReducer?.productReducer?.customerDiscount !== 0 &&
                          item !== item - (item * discount) / 100 ? (
                          <>
                            <strike
                              className="pro-mrp"
                              style={{ textDecoration: "line-through" }}
                            >
                              ₹{item?.toLocaleString()}
                            </strike>
                            &nbsp;&nbsp;
                          </>
                        ) : (
                          <span className="mrl"></span>
                        )}
                        <span className="actual-mrp">
                          ₹
                          {(() => {
                            const value = item - (item * discount) / 100;
                            const isWhole = value % 1 === 0;
                            return value.toLocaleString(undefined, {
                              minimumFractionDigits: isWhole ? 0 : 2,
                              maximumFractionDigits: 2,
                            });
                          })()}
                        </span>
                      </span>
                      {isEarnView ? (
                        isEarnView !== 2 && (
                          <>
                            {(minEarn / getMinPrice(priceDenominations)) *
                              (item - (item * discount) / 100) !==
                              0 && (
                                <div className="fa_star_border1 mt-2">
                                  <span className="fa_star_box">
                                    {translation?.earn}&nbsp;
                                    {Math.round(
                                      (minEarn / getMinPrice(priceDenominations)) *
                                      (item - (item * discount) / 100)
                                    )}{" "}
                                    {translation?.pts}
                                  </span>
                                </div>
                              )}
                          </>
                        )
                      ) : (
                        <>
                          {(minEarn / getMinPrice(priceDenominations)) *
                            (item - (item * discount) / 100) !==
                            0 && (
                              <div className="fa_star_border1 mt-2">
                                <span className="fa_star_box">
                                  {translation?.earn}&nbsp;
                                  {Math.round(
                                    (minEarn / getMinPrice(priceDenominations)) *
                                    (item - (item * discount) / 100)
                                  )}{" "}
                                  {translation?.pts}
                                </span>
                              </div>
                            )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="second-new col-lg-6 col-3 p-0 pl-2"
                  style={{ marginRight: 0 }}
                >

                  {outOfStockLabel?.[index] ? (
                    <div className="stockOutContent">
                      <div className="stockOut">
                        {translation?.out_of_stock}
                      </div>
                    </div>
                  ) :
                    (<div className="input forMob_rights">
                      {quantities[index] > 0 && (
                        <button
                          className="minus minus1"
                          aria-label="Decrease by one"
                          onClick={() => handleDecrease(index, item)}
                        >
                          <svg
                            width="16"
                            height="2"
                            viewBox="0 0 16 2"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <line
                              y1="1"
                              x2="14"
                              y2="1"
                              stroke="var(--plus-minus-color)"
                              strokeWidth="2"
                              className="icon"
                            ></line>
                          </svg>
                        </button>
                      )}
                      {quantities[index] > 0 && (
                        <div className="number dim mb-3 gift_qty_box">
                          {quantities[index]}
                        </div>
                      )}
                      <button
                        className={`plus plus1 ${supplierCapping > 0 && quantities[index] === supplierCapping
                          ? "quantity-disabled"
                          : ""
                          }`}
                        aria-label="Increase by one"
                        onClick={() => handleIncrease(index, item)}
                        disabled={
                          (supplierCapping > 0 &&
                            quantities[index] === supplierCapping) ||
                          V3Data?.disable
                        }
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon"
                        >
                          <line
                            x1="8"
                            y1="0"
                            x2="8"
                            y2="16"
                            stroke="var(--plus-minus-color)"
                            strokeWidth="2"
                          ></line>
                          <line
                            y1="8"
                            x2="16"
                            y2="8"
                            stroke="var(--plus-minus-color)"
                            strokeWidth="2"
                          ></line>
                        </svg>
                      </button>
                    </div>)}
                </div>
              </div>
            ))}
            {V3Data?.disable && (
              <PurchaseLimitAlertTile
                timePeriod={V3Data?.timePeriod}
                amount={V3Data?.amount}
                reset_text={V3Data?.reset_text}
                name={productReducer?.productReducer?.name}
              />
            )}

            {isMobile && <>
              <RewardWidget
                totalAmount={
                  finalAmount -
                  (finalAmount * discount) / 100 +
                  ((finalAmount - (finalAmount * discount) / 100) * convenienceFee) /
                  100 +
                  (((finalAmount - (finalAmount * discount) / 100) * convenienceFee) /
                    100) *
                  (gst / 100)
                }
                className={V3Data?.disable ? "mt-3" : ""}
              /> </>}

            <span className="gift-card-bord"></span>
            <>
              <div className="d-flex justify-content-between mt-4 redem-buy-sp redem-buy-now">
                <div className="belowvalue">
                  <span className="lip">
                    {totalGiftcard} {translation?.giftCard}
                    {totalGiftcard > 1 ? "s" : ""}
                  </span>
                  &nbsp;&nbsp;&nbsp;
                  {isEarnView ? (
                    isEarnView !== 2 && (
                      <>
                        {(finalAmount - (finalAmount * discount) / 100) *
                          (minEarn / getMinPrice(priceDenominations)) !==
                          0 && (
                            <div className="fa_star_border finalPoints f-star-bg">
                              <span className="fa_star_box1">
                                {translation?.earn}&nbsp;
                                {Math.round(
                                  (finalAmount - (finalAmount * discount) / 100) *
                                  (minEarn / getMinPrice(priceDenominations))
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 2,
                                })}{" "}
                                {translation?.pts}
                              </span>
                            </div>
                          )}
                      </>
                    )
                  ) : (
                    <>
                      {(finalAmount - (finalAmount * discount) / 100) *
                        (minEarn / getMinPrice(priceDenominations)) !==
                        0 && (
                          <div className="fa_star_border finalPoints f-star-bg">
                            <span className="fa_star_box1">
                              {translation?.earn}&nbsp;
                              {Math.round(
                                (finalAmount - (finalAmount * discount) / 100) *
                                (minEarn / getMinPrice(priceDenominations))
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                              })}{" "}
                              {translation?.pts}
                            </span>
                          </div>
                        )}
                    </>
                  )}
                </div>
                <div className="belowvalueright">
                  <span className="prorightp">₹{finalAmount.toLocaleString()}</span>
                </div>
              </div>

              {discount > 0 && (
                <div className="d-flex justify-content-between mt-2 redem-buy-now">
                  <div className="belowvalue">
                    <span className="lip">{translation?.discount}</span>
                  </div>
                  <div className="belowvalueright">
                    <span className="prorightp">
                      ₹
                      {(() => {
                        const discountAmount =
                          finalAmount -
                          (finalAmount - (finalAmount * discount) / 100);

                        return discountAmount % 1 === 0
                          ? discountAmount.toLocaleString()
                          : discountAmount.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          });
                      })()}
                    </span>
                  </div>
                </div>
              )}

              {totalGiftcard > 0 && (convenienceFee > 0 || gst > 0) && (
                <div className="d-flex justify-content-between mt-2 redem-buy-now">
                  <div className="belowvalue">
                    {convenienceFee > 0 && (
                      <>
                        <span className="lip d-block">
                          {translation?.convenience_fe}
                        </span>
                        <span className="lip">({convenienceFee}%)</span>
                      </>
                    )}
                    {gst > 0 && <span className="lip">{translation?.plus_gst}</span>}
                  </div>
                  <div className="belowvalueright">
                    <span className="prorightp">
                      ₹
                      {(() => {
                        const amount =
                          ((finalAmount - (finalAmount * discount) / 100) *
                            (convenienceFee || 0)) /
                          100 +
                          (((finalAmount - (finalAmount * discount) / 100) *
                            (convenienceFee || 0)) /
                            100) *
                          ((gst || 0) / 100);

                        return amount % 1 === 0
                          ? amount.toLocaleString()
                          : amount.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          });
                      })()}
                    </span>
                  </div>
                </div>
              )}
              <div className="d-flex justify-content-between mt-2 redem-buy-now">
                <div className="belowvalue">
                  <span className="lip_totalAmount">{translation?.totalAmount}</span>
                </div>
                <div className="belowvalueright">
                  <span className="prorightp">
                    ₹
                    {(() => {
                      const amount =
                        finalAmount -
                        (finalAmount * discount) / 100 +
                        ((finalAmount - (finalAmount * discount) / 100) *
                          convenienceFee) /
                        100 +
                        (((finalAmount - (finalAmount * discount) / 100) *
                          convenienceFee) /
                          100) *
                        (gst / 100);
                      return amount % 1 === 0
                        ? amount.toLocaleString()
                        : amount.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        });
                    })()}
                  </span>
                </div>
              </div>

              <div className="mobile-sticky-footer">
                <div className="mt-3 redem-buy-sp text-center mb-2 giftBuyBtn">
                  <a
                    className="continue-wh buy-detailpro buy-stockupDetailpro"
                    onClick={V3Data?.disable ? undefined : handleClick}
                    style={{
                      cursor: V3Data?.disable ? "not-allowed" : "pointer",
                      backgroundColor: V3Data?.disable
                        ? "var(--disable-continue-color)"
                        : "var(--login-button-color)",
                    }}
                  >
                    {translation?.continue}
                  </a>
                </div>
                <div className="redeem-padd info-box text-center redeem-pt">
                  <span className="redeem-txt-clr">{`${translation?.redeem_text} `}</span>
                  {translation?.redeemPointsCheckout}
                </div>
              </div>
            </>
          </div>
        </div>
      )}
    </div>
  );
};

export default RedemptionDetails;
